exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".RawMaterialArticles{color:red}.angucomplete-dropdown{overflow-y:auto;max-height:200px}.highlight{color:#1934c9}.input-number{width:80px;padding:0 12px;vertical-align:top;text-align:center;outline:none}.input-number,.input-number-decrement,.input-number-increment{border:1px solid #ccc;height:34px;user-select:none}.input-number-decrement,.input-number-increment{display:inline-block;width:30px;line-height:32px;background:#f1f1f1;color:#444;text-align:center;font-weight:700;cursor:pointer}.input-number-decrement:active,.input-number-increment:active{background:#ddd}.input-number-decrement{border-right:none;border-radius:4px 0 0 4px}.input-number-increment{border-left:none;border-radius:0 4px 4px 0}.table-article>tbody>tr>td{vertical-align:middle}.saveicon{margin-bottom:3px;padding:7px 10px!important}.fixed-table-article{margin-top:20px}.input-number::-webkit-inner-spin-button,.input-number::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/raw-material-articles/raw-material-articles.scss
// module id = 1422
// module chunks = 0